<template>
  <div>

    <!-- Alerts -->

    <div v-if="showWarning" class="alert alert-info">
      {{ $t('missing_selected_snapshots') }}
    </div>

    <!-- Content -->

    <div class="container">
      <div v-if="!isRecipient" class="row">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">{{ $t('reports.results') }}</th>
                <th scope="col">{{ $t('reports.filter') }}</th>
                <th scope="col">{{ $t('reports.todisplay') }}</th>
                <th scope="col">{{ $t('reports.sort') }}</th>
                <th scope="col">{{ $t('reports.type') }}</th>
                <th scope="col">{{ $t('reports.items') }}</th>
                <th scope="col">{{ $t('reports.actions.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(resultrow, index) in resultsRows" :class="displayReports[index] ? 'bg-light' : ''">
                <!-- Results -->
                <td>{{ $t(resultrow) }}</td>

                <!-- Filters -->
                <td>
                  <select :name="resultrow + 'filter'" v-model="filtersValues[index]" class="custom-select custom-select-sm">
                    <option v-for="option in filters" :value="option.id">
                      {{ $t('reports.filters.' + option.text) }}
                    </option>
                  </select>
                </td>

                <!-- To display (checkboxes) -->
                <td>
                  <div class="row">
                    <div class="col">
                      <span v-for="display in toDisplay.slice(0, 3)" class="custom-control custom-checkbox">
                        <input :id="index+display.text" :value="display.id" v-model="displayValues[index]" type="checkbox" class="custom-control-input">
                        <label :for="index+display.text" class="custom-control-label small">{{ $t('reports.displays_small.' + display.text) }}</label>
                      </span>
                    </div>
                    <div class="col">
                      <span v-for="display in toDisplay.slice(3)" class="custom-control custom-checkbox">
                        <input :id="index+display.text" :value="display.id" v-model="displayValues[index]" type="checkbox" class="custom-control-input">
                        <label :for="index+display.text" class="custom-control-label small">{{ $t('reports.displays_small.' + display.text) }}</label>
                      </span>
                    </div>
                  </div>
                </td>

                <!-- Sorting -->
                <td>
                  <select :name="resultrow+ 'sort'" v-model="sortValues[index]" class="custom-select custom-select-sm">
                    <option v-for="option in sorts" :value="option.id">
                      {{ $t('reports.sorts.' + option.text) }}
                    </option>
                  </select>
                </td>

                <!-- Sorting order -->
                <td>
                  <select :name="resultrow+ 'type'" v-model="typesValues[index]" class="custom-select custom-select-sm" @change="typeChanged(index)">
                    <option v-for="option in types" :value="option.id">
                      {{ $t('reports.types.' + option.text) }}
                    </option>
                  </select>
                </td>

                <!-- Items -->
                <td>
                  {{ itemsCount[index] }}
                </td>

                <!-- Actions -->
                <td style="min-width: 6rem">
                  <a v-for="action in actions" v-if="displayAction[resultrow][action.id]" :title="$t('reports.actions.'+action.text)" href="#" @click="routeActionFilters(index, action.id)">
                    <fa :icon="action.icon" size="lg" fixed-width/>
                  </a>
                </td>
              </tr>

              <tr v-for="(otherrow, index) in otherRows" :class="displayMap[otherrow] ? 'bg-light':''">
                <td>{{ $t('reports.displays.' + otherrow) }}</td>
                <td v-if="otherRowsShowDetails[index]">
                  <div class="custom-control custom-checkbox">
                    <Checkbox :name="otherrow + 'showdetails'" v-model="otherRowsShowDetailsValues[index]">{{ $t('reports.show_details') }}</Checkbox>
                  </div>
                </td>
                <td v-else-if="otherrow == 'diagram'" style="vertical-align:top !important;">
                  {{ $t('selected') }} : <br>
                  {{ requirementSnapshot != null ? requirementSnapshot.title : '' }}
                </td>
                <td v-else/>
                <td colspan="2" vertical-align="top">
                  <div v-if="otherrow == 'diagram'">
                    <label>{{ $t('tocomparewith') }}</label>
                    <select v-if="chartRequirements.length > 0" v-model="selectedRequirementsDiagram" class="custom-select custom-select-sm" name="requirementsDiagram" multiple rows="3">
                      <option v-for="(requirement, i) in chartRequirements" :value="requirement.id">
                        {{ requirement.title }}
                      </option>
                    </select>
                  </div>
                </td>
                <td colspan="2"/>
                <td><a v-for="action in actions" v-if="displayAction[otherrow][action.id]" :title="$t('reports.actions.'+action.text)" href="#" @click="routeAction(index, action.id)"><fa :icon="action.icon" size="lg" fixed-width/></a></td>
              </tr>

              <tr>
                <td>{{ $t('reports.displays.others') }}</td>
                <td colspan="5">
                  <div class="row">
                    <div class="col-md-4">
                      <select v-model="selectedDropdownReport" class="custom-select custom-select-sm" name="othersreports">
                        <option v-for="(ddReport, i) in dropdownRows" :value="i">
                          {{ $t('reports.displays.' + ddReport) }}
                        </option>
                      </select>
                    </div>
                    <div v-if="this.selectedDropdownReport == 2" class="col-md-8"> <!-- masks -->
                      <select v-if="masks.length > 0" v-model="selectedMask" class="custom-select custom-select-sm" name="mask" >
                        <option v-for="(mask, i) in masks" :value="mask.id">
                          {{ mask.title }}
                        </option>
                      </select>
                      <span v-else>{{ $t('evaluation.mask.no_mask') }}</span>
                    </div>
                    <div v-if="this.selectedDropdownReport == 3" class="col-md-8"> <!-- abilities -->
                      <select v-if="abilities.length > 0" v-model="selectedAbility" class="custom-select custom-select-sm" name="ability" >
                        <option v-for="(ability, i) in abilities" :value="ability.id">
                          {{ ability.title }}
                        </option>
                      </select>
                      <span v-else>{{ $t('reports.error.no_ability') }}</span>
                    </div>
                    <div v-if="this.selectedDropdownReport == 4" class="col-md-8"> <!-- requirements -->
                      <select v-if="requirements.length > 0" v-model="selectedRequirement" class="custom-select custom-select-sm" name="requirement" >
                        <option v-for="(requirement, i) in requirements" :value="requirement.id">
                          {{ requirement.title }}
                        </option>
                      </select>
                      <span v-else>{{ $t('reports.error.no_requirement') }}</span>
                    </div>
                    <div v-if="this.selectedDropdownReport == 5" class="col-md-8"> <!-- perceptions -->
                      <select v-if="perceptions.length > 0" v-model="selectedPerception" class="custom-select custom-select-sm" name="perception" >
                        <option v-for="(perception, i) in perceptions" :value="perception.id">
                          {{ perception.title }}
                        </option>
                      </select>
                      <span v-else>{{ $t('reports.error.no_perception') }}</span>
                    </div>
                  </div>
                </td>
                <td><a v-for="action in actions" v-if="displayAction['other'][dropdownRows[selectedDropdownReport]][action.id]" :title="$t('reports.actions.'+action.text)" href="#" @click="routeDropdownAction(action.id)"><fa :icon="action.icon" size="lg" fixed-width/></a></td>
              </tr>
              <!-- TODO Add downloadables here -->
              <tr>
                <td>{{ $t('reports.downloadables.title') }}</td>
                <td colspan="5">
                  <div class="row">
                    <div class="col-md-4">
                      <select v-model="selectedDownloadableReport" class="custom-select custom-select-sm" name="downloadables">
                        <option v-for="(dwnReport, i) in dropdownRowsDownloadable" :value="dwnReport">
                          {{ $t('reports.downloadables.' + dwnReport) }}
                        </option>
                      </select>
                    </div>
                  </div>
                </td>
                <td><a v-for="action in actions" v-if="action.id == 2" :title="$t('reports.actions.'+action.text)" href="#" @click="downloadDropdownAction(action.id)"><fa :icon="action.icon" size="lg" fixed-width/></a></td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>

      <!-- Body -->
      <div v-if="!isRecipient" id="reports-content" ref="reportsContent">
        <div class="WordSection1">
          <h1 v-if="title">{{ $t(`reports.titles.${title}`) }}</h1>
          <div v-if="displayChart">
            <ReportHeader id="header" ref="header" :tableid="headertable" :user="user" :recipient="recipient" :organization="user.organization" :ability-snapshot="abilitySnapshot" :requirement-snapshot="requirementSnapshot" :perception-snapshot="perceptionSnapshot" :full-header="fullHeader" />
          </div>
          <div v-else-if="displayAssessments[0]">
            <ReportHeader id="header" ref="header" :tableid="headertable" :user="user" :recipient="recipient" :organization="user.organization" :ability-snapshot="assessmentsSnapshots[0]" :full-header="fullHeader" />
          </div>
          <div v-else-if="displayAssessments[1]">
            <ReportHeader id="header" ref="header" :tableid="headertable" :user="user" :recipient="recipient" :organization="user.organization" :requirement-snapshot="assessmentsSnapshots[1]" :full-header="fullHeader" />
          </div>
          <div v-else-if="displayAssessments[2]">
            <ReportHeader id="header" ref="header" :tableid="headertable" :user="user" :recipient="recipient" :organization="user.organization" :perception-snapshot="assessmentsSnapshots[2]" :full-header="fullHeader" />
          </div>
          <div v-else-if="displayDecisions">
            <ReportHeader id="header" ref="header" :tableid="headertable" :user="user" :recipient="recipient" :organization="user.organization" :ability-snapshot="abilitySnapshot" :requirement-snapshot="requirementSnapshot" :full-header="fullHeader" :show-recipient="true"/>
          </div>
          <div v-else>
            <ReportHeader id="header" ref="header" :tableid="headertable" :user="user" :recipient="recipient" :organization="user.organization" :ability-snapshot="abilitySnapshot" :requirement-snapshot="requirementSnapshot" :full-header="fullHeader" />
          </div>

          <div v-if="displayChart" id="chart" class="row">
            <div :id="otherRows[2]" class="col-sm-9">
              <template v-for="(data, index) in radarValues">
                <RadarChart ref="chart" :chart-data="chartData(index)" :labels-values="displayLabelsValues"/>
              </template>
            </div>
            <div class="col-sm-3">
              <div class="card">
                <div class="card-header">{{ $t('reports.axis.axis') }}</div>
                <div class="card-body">
                  <div v-for="ax in axis">
                    <input :id="'ax'+ax" :value="ax" v-model="labels" type="checkbox">
                    <label :for="'ax'+ax" class="col-form-label text-md-right">{{ $t('evaluations.requirements.titles.' + ax) }}</label>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header">{{ $t('reports.values') }}</div>
                <div class="card-body">
                  <div v-for="ev in evaluations">
                    <input :id="ev.title+'cbx'" :value="ev.title" v-model="values" type="checkbox">
                    <label :for="ev.title+'cbx'" class="col-form-label text-md-right">{{ $t(ev.title) }}</label>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header">{{ $t('reports.display_options') }}</div>
                <div class="card-body">
                  <div>
                    <input id="labelsvaluescbx" v-model="displayLabelsValues" type="checkbox">
                    <label for="labelsvaluescbx" class="col-form-label text-md-right">{{ $t('reports.display_labels_values') }}</label>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div v-for="(resultrow, index) in resultsRows" v-if="displayReports[index]">
            <ReportDisplay v-if="reports[index]" :id="resultrow" :tableid="resultrow+'table'" :report="reports[index]" :todisplay="columns(index)"
                           :sort="sortValues[index]" :type="typesValues[index]" :filter="filtersValues[index]" @icc="(...args) => itemsCountChange(index, ...args)"/>
          </div>
          <div v-if="displaySynthesis">
            <SynthesisDisplay v-if="synthesis" ref="synthesis" :id="otherRows[0]" :tableid="otherRows[0]+'table'" :report="synthesis" :show-details="otherRowsShowDetailsValues[0]"/>
          </div>
          <div v-if="displayPenibility">
            <PenibilityDisplay v-if="penibility" ref="penibility" :id="otherRows[1]" :tableid="otherRows[1]+'table'" :penibility="penibility" :show-details="otherRowsShowDetailsValues[1]"/>
          </div>
          <div v-if="displayProfile">
            <ProfileDisplay ref="profile" :id="dropdownRows[0]" :tableid="dropdownRows[0]+'table'" :profile="recipient"/>
          </div>
          <div v-if="displayAccompanyingS">
            <AccompanyingSheetDisplay ref="accsheet" :id="dropdownRows[1]" :tableid="dropdownRows[1]+'table'" :snapshot="requirementSnapshot"/>
          </div>
          <div v-if="displayMask">
            <MaskDisplay ref="mask" :id="dropdownRows[2]" :tableid="dropdownRows[2]+'table'" :mask="maskObj"/>
          </div>
          <div v-for="(assessmentrow, index) in assessmentsRows" v-if="displayAssessments[index]">
            <ReportCommentsDisplay v-if="assessments[index]" :id="assessmentrow" :tableid="assessmentrow+'table'" :report="assessments[index]" :todisplay="toDisplayAssessments"
                                   :sort="sortValues[index]" :type="typesValues[index]" :filter="filtersValues[index]"/>
          </div>
          <div v-if="displayDecisions">
            <DecisionsReport :tableid="dropdownRows[6]+'table'" :recipient="recipient"/>
          </div>
        </div>
      </div>

      <div v-if="filteredArchives.length">
        <div class="w-75 mx-auto">
          <h3>{{ $t('archived_reports') }}</h3>
          <table class="table">
            <thead>
              <tr>
                <th width="100">{{ $t('date') }}</th><th>{{ $t('title') }}</th><th width="100">{{ $t('actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="archive in filteredArchives">
                <td>{{ formatDate(archive.created_at) }}</td>
                <td>{{ archive.title }}</td>
                <td>
                  <a v-if="archive.file" :href="`/api/reportarchives/${archive.id}/download`" target="_blank"><fa icon="arrow-down" size="lg" fixed-width/></a>
                  <a v-if="true" href="#" @click="deleteArchive(archive)"><fa icon="trash" size="lg" fixed-width/></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { RadarChart } from '~/components/RadarChart'
import { ReportDisplay } from '~/components/ReportDisplay'
import { ReportCommentsDisplay } from '~/components/ReportCommentsDisplay'
import { SynthesisDisplay } from '~/components/SynthesisDisplay'
import { PenibilityDisplay } from '~/components/PenibilityDisplay'
import { isCurrentUser } from '~/plugins/auth'
import jsPDF from 'jspdf'
import jsPDFAutoTable from 'jspdf-autotable'
import FontMetrics from 'fontmetrics'
import html2canvas from 'html2canvas'
import wordTemplate from '~/data/WordTemplate.html'
import { isRecipient } from '~/plugins/auth'

export default {
  name: 'Reports',

  props: {
    recipient: { required: true, type: Object },
    abilitySnapshot: null,
    requirementSnapshot: null,
    perceptionSnapshot: null,
    masks: { required: true, type: Array },
    aptMask: { required: true, type: Number }
  },

  computed: {
    isRecipient () {
      return isRecipient(this.user)
    },
    filteredArchives: function () {
      return this.archives.filter(x => x.user_id == this.recipient.id)
    },
    chartRequirements: function () {
      var parent = this
      return this.requirements.filter(function (el) {
        return el.id != parent.requirement
      })
    },
    ability: function () {
      return this.abilitySnapshot == null ? 0 : this.abilitySnapshot.id
    },
    requirement: function () {
      return this.requirementSnapshot == null ? 0 : this.requirementSnapshot.id
    },
    perception: function () {
      return this.perceptionSnapshot == null ? 0 : this.perceptionSnapshot.id
    },
    requirementName: function () {
      if (this.requirement > 0) {
        return this.requirementsEvals.filter(function (r) { return r.id == this.requirement }, this)[0].title
      }
      return ''
    },
    headerText () {
      const date = new Date().toJSON().slice(0, 10).split('-').reverse().join('/')

      let text = [
        'ESAP', date, '-',
        this.$t('created_by'), this.user.first_name, this.user.last_name,
        this.$t('from'), this.user.organization.name
      ]

      if (this.fullHeader && this.recipient && this.user) {
        text.splice(2, 0, this.recipient.first_name, this.recipient.last_name)
      }

      return text.join(' ')
    },
    displayMap: function () {
      var keys = this.otherRows
      var values = [this.displaySynthesis, this.displayPenibility, this.displayChart, this.displayProfile, this.displayAccompanyingS]
      var map = {}
      keys.forEach((key, i) => map[key] = values[i])
      return map
    },
    maskObj: function () {
      if (this.selectedMask > 0) {
        return this.masks.filter(x => x.id == this.selectedMask)[0]
      }
      return null
    },
    backgroundColors: function () { return { 'abilities': this.getColorString('abilities', 0.3), 'requirements': this.getColorString('requirements', 0.3), 'perceptions': this.getColorString('perceptions', 0.3) } },
    borderColors: function () { return { 'abilities': this.getColorString('abilities', 0.8), 'requirements': this.getColorString('requirements', 0.8), 'perceptions': this.getColorString('perceptions', 0.8) } },
    pointBackgroundColors: function () { return { 'abilities': this.getColorString('abilities', 1), 'requirements': this.getColorString('requirements', 1), 'perceptions': this.getColorString('perceptions', 1) } },
    pointHoverBorderColors: function () { return { 'abilities': '#000', 'requirements': '#000', 'perceptions': '#000' } },
    pointBorderColors: function () { return { 'abilities': this.getColorString('abilities', 1), 'requirements': this.getColorString('requirements', 1), 'perceptions': this.getColorString('perceptions', 1) } },
    pointHoverBackgroundColors: function () { return { 'abilities': this.getColorString('abilities', 1), 'requirements': this.getColorString('requirements', 1), 'perceptions': this.getColorString('perceptions', 1) } },
    ...mapGetters({
      evaluations: 'evaluations/evaluations',
      user: 'auth/user'
    })
  },

  created () {
    window.html2canvas = html2canvas
    this.initializeValues()
  },

  data: () => ({
    resultsRows: ['abilities', 'requirements'],
    otherRows: ['synthesis', 'painfulness', 'diagram'],
    otherRowsShowDetails: [true, true, false],
    otherRowsShowDetailsValues: [false, false, false],
    dropdownRows: ['profile', 'accompanying_sheet', 'masks', 'abilities', 'requirements', 'perceptions', 'decisions'],
    assessmentsRows: ['abilities', 'requirements', 'perceptions'],
    assessmentsSnapshots: [],
    selectedDropdownReport: 0, // profile selected by default
    dropdownRowsDownloadable: ['my_perception', 'abilities', 'requirements', 'dcip', 'evaluation', 'glossary', 'esap_decisions', 'deparis'],
    selectedDownloadableReport: 0, // profile selected by default
    selectedMask: 0,
    selectedAbility: 0,
    selectedRequirement: 0,
    selectedRequirementsDiagram: [],
    selectedPerception: 0,
    filters: [{ id: 1, text: 'none' }, { id: 2, text: 'prioritary_fail' }, { id: 3, text: 'details_fails' }, { id: 4, text: 'all_fails' }, { id: 5, text: 'without_fails' }],
    sorts: [{ id: 1, text: 'code' }, { id: 2, text: 'description' }, { id: 3, text: 'prioritary_fails' }, { id: 4, text: 'details_fails' }, { id: 5, text: 'fails' }, { id: 6, text: 'value' }],
    types: [{ id: 1, text: 'ascendant' }, { id: 2, text: 'descendant' }],
    toDisplay: [{ id: 1, text: 'code' }, { id: 2, text: 'description' }, { id: 3, text: 'comment' }, { id: 5, text: 'fails' }, { id: 6, text: 'value' }], // {id:3, text:'prioritary'}, {id:4, text:'details'}],
    toDisplayAssessments: ['code', 'description', 'comment', 'value'],
    itemsCount: [],
    actions: [{ id: 1, text: 'visualize', icon: 'eye' }, { id: 2, text: 'generate_pdf', icon: 'file-pdf' }, { id: 3, text: 'generate_word', icon: 'file-word' }, { id: 4, text: 'generate_csv', icon: 'file-excel' }, { id: 5, text: 'save_pdf_recipient', icon: 'arrow-up' }],
    displayAction: {
      'abilities': [false, true, true, true, true, true],
      'requirements': [false, true, true, true, true, true],
      'synthesis': [false, true, true, true, false, true],
      'painfulness': [false, true, true, true, true, false],
      'diagram': [false, true, true, true, false, true],
      'other': {
        'profile': [false, true, true, true, false, false],
        'accompanying_sheet': [false, true, true, true, false, false],
        'masks': [false, true, true, true, false, false],
        'abilities': [false, true, true, true, true, true],
        'requirements': [false, true, true, true, true, true],
        'perceptions': [false, true, true, true, true, true],
        'decisions': [false, true, true, true, false, false]
      }
    },
    filtersValues: [],
    sortValues: [],
    typesValue: [],
    displayValues: [],
    axis: [1, 2, 3, 4, 5, 6],
    labels: [1, 2, 3, 4, 5, 6],
    values: [],
    display: [],
    reports: [],
    assessments: [],
    decisions: [],
    synthesis: null,
    penibility: null,
    radarValues: null,
    displayChart: false,
    displayReports: [],
    displayAssessments: [],
    displaySynthesis: false,
    displayPenibility: false,
    displayProfile: false,
    displayAccompanyingS: false,
    displayMask: false,
    displayDecisions: false,
    displayLabelsValues: true,
    showWarning: false,
    headertable: 'header-table',
    pdfTopMargin: 20, // mm
    pdfDefaultFontSize: 8,
    preHtml: "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>ESAP</title></head><body>",
    postHtml: '</body></html>',
    wordLandscape: '@page WordSection1{size: 841.95pt 595.35pt;mso-page-orientation: landscape;}div.WordSection1 {page: WordSection1;}',
    title: '',
    fullHeader: true,
    abilities: [],
    requirements: [],
    perceptions: [],
    archives: []
  }),
  mounted: function () {
    this.getAbilities()
    this.getRequirements()
    this.getPerceptions()
    this.getArchives()
  },

  methods: {
    formatDate (document_date) {
      return new Date(document_date).toUserLocaleDateString(this)
    },
    initializeValues () {
      this.filtersValues = []
      this.sortValues = []
      this.typesValues = []
      this.displayValues = []

      for (var i = 0; i < this.resultsRows.length; i++) {
        this.filtersValues.push(this.filters[0].id)
        this.sortValues.push(this.sorts[0].id)
        this.typesValues.push(this.types[0].id)
        this.displayValues.push([1, 2, 3, 5, 6])
        this.reports.push(null)
        this.displayReports.push(false)
      }

      this.values = this.evaluations.map(x => x.title)
      this.itemsCount = this.resultsRows.map(x => 0)
    },

    routeActionFilters (rowIndex, idAction) {
      this.showWarning = !(this.ability > 0 && this.requirement > 0)
      if (this.showWarning) { return }

      this.getReport(rowIndex).then(success => {
        if (success) {
          this.title = this.resultsRows[rowIndex]
          var filename = new Date().toJSON().slice(0, 10)
          filename += '_' + this.recipient.first_name + '-' + this.recipient.last_name + '_' + this.$t('reports.displays.' + this.resultsRows[rowIndex]) +
                          '_' + this.$t('reports.report')
          var title = this.$t('reports.displays.' + this.resultsRows[rowIndex]) + ' : '
          title += (rowIndex == 0) ? this.abilitySnapshot.title : this.requirementSnapshot.title
          switch (idAction) {
            case 2: // generate pdf for current row
              var tableId = '#' + this.resultsRows[rowIndex] + 'table'
              this.generateTablePDF(tableId, filename, 'p')
              break
            case 3: // generate word for current row
              this.generateWordDocument(filename)
              break
            case 4: // generate csv for current row
              var tableId = '#' + this.resultsRows[rowIndex] + 'table'
              this.generateCSV(tableId, filename, 'p')
              break
            case 5: // generate pdf for current row
              var tableId = '#' + this.resultsRows[rowIndex] + 'table'
              var pdf = this.generateTablePDF(tableId, filename, 'p', false)
              this.exportPdf(pdf, title)
              break
            case 1: // display details on page
              // nothing more to do
            default:
          }
        } else {
          console.error("Couldn't load report")
        }
      }).catch((err) => console.error(err))
    },

    routeAction (rowIndex, idAction) {
      this.showWarning = !(this.ability > 0 && this.requirement > 0) && rowIndex < 3
      if (this.showWarning) { return }
      var calls = [this.getSynthesis, this.getPenibility, this.getChart, this.showProfile, this.showSheet]
      calls[rowIndex]().then((success) => {
        if (success) {
          this.title = this.otherRows[rowIndex]
          var filename = new Date().toJSON().slice(0, 10)
          filename += '_' + this.recipient.first_name + '-' + this.recipient.last_name + '_' + this.$t('reports.displays.' + this.otherRows[rowIndex]) +
                          '_' + this.$t('reports.report')
          var title = this.$t('reports.displays.' + this.otherRows[rowIndex])
          switch (idAction) {
            case 2: // generate pdf
              var calls = [function (parent) { parent.generateTablePDF('#' + parent.otherRows[rowIndex] + 'table', filename, 'l') },
                function (parent) { parent.generateTablePDFPenibility('#' + parent.otherRows[rowIndex] + 'table', filename, 'p') },
                function (parent) { parent.generateChartPDF('.chartjs-render-monitor', filename, 'p') }]
              calls[rowIndex](this)
              break
            case 3: // generate word
              var calls = [function (parent) { parent.generateWordDocument(filename, 'l') },
                function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateChartWordDocument('.chartjs-render-monitor', filename) }]
              calls[rowIndex](this)
              break
            case 4: // generate csv
              var calls = [function (parent) {},
                function (parent) { parent.generateCSVPenibility(parent.penibility, filename) },
                function (parent) {}]
              calls[rowIndex](this)
              break
            case 5: // save pdf
              var calls = [function (parent) {
                var pdf = parent.generateTablePDF('#' + parent.otherRows[rowIndex] + 'table', filename, 'l', false)
                parent.exportPdf(pdf, title)
              },
              function (parent) {},
              function (parent) {
                var pdf = parent.generateChartPDF('.chartjs-render-monitor', filename, 'p', false)
                parent.exportPdf(pdf, title)
              }]
              calls[rowIndex](this)
              break
            case 1: // display details
              // nothing else to do
            default:
          }
        }
      }).catch((err) => console.error(err))
    },

    routeDropdownAction (idAction) {
      var calls = [this.showProfile, this.showSheet, this.showMask, this.showAbilities, this.showRequirements, this.showPerceptions, this.showDecisions]
      var rowIndex = this.selectedDropdownReport

      calls[rowIndex]().then((success) => {
        if (success) {
          this.title = this.dropdownRows[rowIndex]
          var filename = new Date().toJSON().slice(0, 10)
          if (rowIndex == 0) { filename += '_' + this.recipient.first_name + '-' + this.recipient.last_name }

          filename += '_' + this.$t('reports.displays.' + this.dropdownRows[rowIndex])
          if (rowIndex == 2 && this.maskObj) { filename += '-' + this.maskObj.title }
          filename += '_' + this.$t('reports.report')

          var title = this.$t('reports.displays.' + this.dropdownRows[rowIndex])
          if (rowIndex == 3) { // abilities
            var ability = this.abilities.find(({ id }) => id == this.selectedAbility)
            title += ': ' + ability.title
          } else if (rowIndex == 4) { // requirements
            var requirement = this.requirements.find(({ id }) => id == this.selectedRequirement)
            title += ': ' + requirement.title
          } else if (rowIndex == 5) { // perception
            var perception = this.perceptions.find(({ id }) => id == this.selectedPerception)
            title += ': ' + perception.title
          }

          switch (idAction) {
            case 2: // generate pdf
              var calls = [function (parent) { parent.generateMultiTablePDF(parent.dropdownRows[rowIndex] + 'table', filename, 'p') },
                function (parent) { parent.generateMultiTablePDF(parent.dropdownRows[rowIndex] + 'table', filename, 'p') },
                function (parent) { if (parent.maskObj) parent.generateMaskPDF('#' + parent.dropdownRows[rowIndex], parent.maskObj.title, filename, 'p') },
                function (parent) { parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p') },
                function (parent) { parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p') },
                function (parent) { parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p') },
                function (parent) { parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p') }]
              calls[rowIndex](this)
              break
            case 3: // generate word
              var calls = [function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateWordDocument(filename) },
                function (parent) { parent.generateWordDocument(filename) }]
              calls[rowIndex](this)
              break
            case 4: // generate csv
              var calls = [function (parent) {},
                function (parent) {},
                function (parent) {},
                function (parent) { parent.generateCSV('#' + parent.dropdownRows[rowIndex] + 'table', filename) },
                function (parent) { parent.generateCSV('#' + parent.dropdownRows[rowIndex] + 'table', filename) },
                function (parent) { parent.generateCSV('#' + parent.dropdownRows[rowIndex] + 'table', filename) }]
              calls[rowIndex](this)
              break
            case 5: // save pdf
              var calls = [function (parent) {},
                function (parent) {},
                function (parent) {},
                function (parent) {
                  var pdf = parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p', false)
                  parent.exportPdf(pdf, title)
                },
                function (parent) {
                  var pdf = parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p', false)
                  parent.exportPdf(pdf, title)
                },
                function (parent) {
                  var pdf = parent.generateTablePDF('#' + parent.dropdownRows[rowIndex] + 'table', filename, 'p', false)
                  parent.exportPdf(pdf, title)
                },
                function (parent) {}]
              calls[rowIndex](this)
              break
            case 1: // display details
              // nothing else to do
            default:
          }
        }
      }).catch((err) => console.error(err))
    },

    async exportPdf (pdf, title) {
      let ok = false
      let report = {}

      await axios.post('/api/reportarchives', { 'title': title, 'user_id': this.recipient.id })
        .then((response) => {
          ok = true
          // console.log(response);
          report = response.data
        })
        .catch((error) => {})

      // If resource has been stored/updated...
      if (ok) {
        // Upload pdf
        if (pdf) {
          let formData = new FormData()
          formData.append('report', pdf)

          const config = {
            headers: { 'content-type': 'multipart/form-data' }
          }

          // TODO : Use patch or put if somehow it can work someday
          await axios.post(`/api/reportarchives/${report.id}/report`, formData, config)
            .then((response) => {
              ok &= true
              this.archives.push(response.data)
            })
            .catch((error) => {
              ok &= false
            })
        }
      }
    },

    downloadDropdownAction (idAction) {
      var files = {
        'my_perception': '/downloads/BILAN_DE_MA_PERCEPTION.pdf',
        'abilities': '/downloads/BILAN_DES_APTITUDES_exercice.pdf',
        'requirements': '/downloads/BILAN_DES_EXIGENCES.pdf',
        'dcip': '/downloads/DESCRIPTION_DE_LA_CLASSIFICATION_INTERNATIONALE_DES_PROFESSIONS.pdf',
        'evaluation': '/downloads/ECHELLES_EVALUATION.pdf',
        'glossary': '/downloads/GLOSSAIRE_DES_EXIGENCES.pdf',
        'esap_decisions': '/downloads/LISTE_DES_DECISIONS_ESAP.pdf',
        'deparis': '/downloads/METHODE_DEPARIS.pdf'
      }
      var rowIndex = this.selectedDownloadableReport
      if (rowIndex == 0) { return }

      var filePath = files[rowIndex]
      var fileName = filePath.split('/')
      fileName = fileName[fileName.length - 1]

      axios({
        url: filePath,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        if ('errors' in response) {
          return reject(response)
        } else {
          if (!window.navigator.msSaveOrOpenBlob) {
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
          } else {
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName)
          }
        }
      })
        .catch((err) => {
          return reject(err)
        })

      /* var rowIndex = this.selectedDropdownReport;
      calls[rowIndex]().then((success) => {
        if(success) {
          this.title = this.dropdownRows[rowIndex];
          var filename = new Date().toJSON().slice(0,10);
          if(rowIndex == 0)
            filename += "_" + this.recipient.first_name+'-'+this.recipient.last_name;

          filename += '_' + this.$t('reports.displays.' + this.dropdownRows[rowIndex]);
          if(rowIndex == 2 && this.maskObj)
            filename += '-' + this.maskObj.title;
          filename += '_' + this.$t('reports.report');

          switch (idAction) {
            case 2: // generate pdf
              var calls = [function(parent){parent.generateMultiTablePDF(parent.dropdownRows[rowIndex] + 'table', filename, 'p')},
                            function(parent){parent.generateMultiTablePDF(parent.dropdownRows[rowIndex] + 'table', filename, 'p')},
                            function(parent){if(parent.maskObj) parent.generateMaskPDF('#'+parent.dropdownRows[rowIndex], parent.maskObj.title, filename, 'p')}];
              calls[rowIndex](this);
              break;
            case 3: // generate word
              var calls = [function(parent){parent.generateWordDocument(filename)},
                            function(parent){parent.generateWordDocument(filename)},
                            function(parent){parent.generateWordDocument(filename)}];
              calls[rowIndex](this);
              break;
            case 1: // display details
                // nothing else to do
            default:
          }
        }
      }).catch((err) => console.error(err)); */
    },

    // Get the chart title based on index
    chartTitle: function (index) {
      var parent = this
      if (this.radarValues[index]) {
        var arr = this.requirements.filter(function (el) {
          return el.id == parent.radarValues[index].requirementId
        })
        if (arr.length > 0) { return arr[0].title }
      }
    },

    // Build the chartData props for the radar chart
    chartData: function (index) {
      var sortedLabels = this.labels.slice().sort((a, b) => a > b)
      return {
        title: this.chartTitle(index),
        labels: sortedLabels.map(function (ax) { return this.$t('evaluations.requirements.titles.' + ax) }, this),
        datasets: this.datasets(index)
      }
    },

    datasets: function (index) {
      var datasets = []
      // Code below is test code and must be rewritten
      if (this.radarValues[index] && this.radarValues[index].reports) {
        for (var k in this.radarValues[index].reports) {
          if (this.values.includes(k)) {
            var aspect = this.radarValues[index].reports[k]
            if (aspect) {
              var dataRow = []
              this.labels.slice().sort().map(function (key, index) {
                if (key in aspect) { dataRow.push({ key: key, val: aspect[key].ratio }) } else { dataRow.push({ key: key, val: null }) } // how to interpret axis with no value ?
              })

              datasets.push(
                {
                  label: this.$t(k),
                  backgroundColor: this.backgroundColors[k],
                  borderColor: this.borderColors[k],
                  pointBackgroundColor: this.pointBackgroundColors[k],
                  pointBorderColor: this.pointBorderColors[k],
                  pointHoverBackgroundColor: this.pointHoverBackgroundColors[k],
                  pointHoverBorderColor: this.pointHoverBorderColors[k],
                  data: dataRow.map(a => a.val)
                })
            }
          }
        }
      }
      return datasets
    },

    getColorString (elem, opacity) {
      let hex2rgb = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null
      }

      let hex = '#000000'
      switch (elem) {
        case 'abilities':
          hex = '#e74c3c'
          break
        case 'requirements':
          hex = '#9b59b6'
          break
        case 'perceptions':
          hex = '#16a085'
          break
      }
      var rgb = hex2rgb(hex)
      if (rgb == null) rgb = { r: 0, g: 0, b: 0 }
      return `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`
    },

    columns (index) {
      return this.toDisplay.filter(x => this.displayValues[index].includes(x.id)).map(x => x.text)
    },

    typeChanged (index) {
      // if(this.displayReports[index])
      //   this.displayReports = this.displayReports.map(function(elem, i){return elem == this.displayReports[i]}, this);
      Vue.set(this.displayReports, index, true)
    },

    async getReport (index) {
      var routeSuffix = ['abilities', 'requirements']
      index = index > 0 ? (index < routeSuffix.length ? index : routeSuffix.length - 1) : 0

      return new Promise((resolve, reject) => {
        axios.get(`/api/users/${this.recipient.id}/reports/${routeSuffix[index]}/${this.ability}/${this.requirement}/${this.aptMask}`)
          .then((response) => {
            if ('errors' in response) {
              return reject(response)
            } else {
              this.reports[index] = []
              for (var k in response.data) {
                if (response.data.hasOwnProperty(k)) {
                  var el = response.data[k]
                  el.description = this.$t('evaluations.' + routeSuffix[index] + '.titles.' + k)
                  if (el.fails_list.length > 0) {
                    for (let j = 0; j < el.fails_list.length; j++) {
                      el.fails_list[j].description = this.$t('evaluations.' + routeSuffix[Math.abs(index - 1)] + '.titles.' + el.fails_list[j].id)
                    }
                  }
                  this.reports[index].push(el)
                }
              }

              Vue.set(this.itemsCount, index, this.reports[index].length)
              this.hideAll()
              this.displayReports = this.displayReports.map(function (elem, i) { return i == index })
              return resolve(this.displayReports[index])
            }
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },

    async getSynthesis () {
      return new Promise((resolve, reject) => {
        axios.get(`/api/users/${this.recipient.id}/reports/synthesis/${this.ability}/${this.requirement}/${this.aptMask}`)
          .then((response) => {
            if ('errors' in response) {
              return reject(response)
            } else {
              this.synthesis = []
              for (var k in response.data) {
                if (response.data.hasOwnProperty(k)) {
                  var el = response.data[k]
                  el.description = this.$t('evaluations.requirements.titles.' + k)
                  el.prioritary_fails = this.augmentWithDescription(el.prioritary_fails, 'evaluations.abilities.titles.')
                  el.details_fails = this.augmentWithDescription(el.details_fails, 'evaluations.abilities.titles.')
                  this.synthesis.push(el)
                }
              }
              this.hideAll()
              this.displaySynthesis = true
              return resolve(this.displaySynthesis)
            }
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },

    async getPenibility () {
      return new Promise((resolve, reject) => {
        axios.get(`/api/users/${this.recipient.id}/reports/penibility/${this.ability}/${this.requirement}/${this.aptMask}`)
          .then((response) => {
            if ('errors' in response) {
              return reject(response)
            } else {
              var data = response.data
              data['global'] = this.augmentWithDescription(data['global'], 'evaluations.requirements.titles.')
              data['physical'] = this.augmentWithDescription(data['physical'], 'evaluations.requirements.titles.')
              data['intellectual'] = this.augmentWithDescription(data['intellectual'], 'evaluations.requirements.titles.')
              this.penibility = data
              this.hideAll()
              this.displayPenibility = true
              return resolve(this.displayPenibility)
            }
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },

    async getChart () {
      return new Promise((resolve, reject) => {
        var requests = []
        var ids = this.selectedRequirementsDiagram.slice()
        ids.unshift(this.requirement)

        ids.forEach((id) => {
          requests.push(this.loadChart(id))
        })

        Promise.all(requests).then((chartsData) => {
          this.radarValues = chartsData
          this.hideAll()
          this.displayChart = true
          resolve(true)
        })
      })
    },

    async loadChart (requirementId) {
      var perceptionId = this.perception
      if (!perceptionId) perceptionId = 0 // optional perception

      return new Promise((resolve, reject) => {
        axios.get(`/api/users/${this.recipient.id}/reports/chart/${this.ability}/${requirementId}/${perceptionId}/${this.aptMask}`)
          .then((response) => {
            if ('errors' in response) {
              return reject(response)
            } else {
              return resolve(response.data)
            }
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },

    async showProfile () {
      this.hideAll()
      this.fullHeader = false
      this.displayProfile = true
      var promise = new Promise((resolve, reject) => {
        setTimeout(function () {
          resolve(this.displayProfile)
        }, 250)
      })
      return new Promise((resolve, reject) => {
        const res = promise.then((success) => resolve(this.displayProfile))
      })
    },

    async showSheet () {
      this.hideAll()
      this.fullHeader = false
      this.displayAccompanyingS = true
      var promise = new Promise((resolve, reject) => {
        setTimeout(function () {
          resolve(this.displayAccompanyingS)
        }, 250)
      })
      return new Promise((resolve, reject) => {
        const res = promise.then((success) => resolve(this.displayAccompanyingS))
      })
    },

    async showMask () {
      this.hideAll()
      this.fullHeader = false
      this.displayMask = true
      var promise = new Promise((resolve, reject) => {
        setTimeout(function () {
          resolve(this.displayMask)
        }, 250)
      })
      return new Promise((resolve, reject) => {
        const res = promise.then((success) => resolve(this.displayMask))
      })
    },
    async showDecisions () {
      this.hideAll()
      this.fullHeader = false
      // Display decisions
      this.displayDecisions = true
      return new Promise((resolve, reject) => {
        try {
          setTimeout(function () {
            return resolve(true)
          }, 250)
        } catch (err) {
          return reject(err)
        }
      })
    },
    async showAbilities () {
      this.hideAll()
      return new Promise((resolve, reject) => {
        try {
          // Get the abilities
          var tree = this.$store.getters['evaluations/abilities'].tree
          var defaultValue = this.$store.getters['evaluations/abilities'].defaultValue
          var parent = this
          // Get the snapshot
          var snapshot = this.abilities.find(function (el) {
            return el.id == parent.selectedAbility
          })
          // Get assessment index
          var assessmentIndex = this.assessmentsRows.findIndex(function (el) { return el == 'abilities' })
          this.assessments[assessmentIndex] = []

          // Store snapshot for other parts (header)
          this.assessmentsSnapshots[assessmentIndex] = snapshot

          // Parse the actual snapshot data
          snapshot = JSON.parse(snapshot.snapshot)
          let index = [ 0 ] // Value in array so it can be passed by reference.

          // Get assessment index
          var assessmentIndex = this.assessmentsRows.findIndex(function (el) { return el == 'abilities' })
          this.assessments[assessmentIndex] = []

          // Prepare the assessment
          this.$_prepareAssessment(snapshot, index, tree[0], defaultValue, '', assessmentIndex)

          // Display assessment
          Vue.set(this.displayAssessments, assessmentIndex, true)

          setTimeout(function () {
            return resolve(parent.displayAssessments[assessmentIndex])
          }, 250)
        } catch (err) {
          return reject(err)
        }
      })
    },
    async showRequirements () {
      this.hideAll()
      return new Promise((resolve, reject) => {
        try {
          // Get the requirements
          var tree = this.$store.getters['evaluations/requirements'].tree
          var defaultValue = this.$store.getters['evaluations/requirements'].defaultValue
          var parent = this
          // Get the snapshot
          var snapshot = this.requirements.find(function (el) {
            return el.id == parent.selectedRequirement
          })
          // Get assessment index
          var assessmentIndex = this.assessmentsRows.findIndex(function (el) { return el == 'requirements' })
          this.assessments[assessmentIndex] = []

          // Store snapshot for other parts (header)
          this.assessmentsSnapshots[assessmentIndex] = snapshot

          // Parse the actual snapshot data
          snapshot = JSON.parse(snapshot.snapshot)
          let index = [ 0 ] // Value in array so it can be passed by reference.

          // Prepare the assessment
          this.$_prepareAssessment(snapshot, index, tree[0], defaultValue, '', assessmentIndex)

          // Display assessment
          Vue.set(this.displayAssessments, assessmentIndex, true)

          setTimeout(function () {
            return resolve(parent.displayAssessments[assessmentIndex])
          }, 250)
        } catch (err) {
          return reject(err)
        }
      })
    },
    async showPerceptions () {
      this.hideAll()
      return new Promise((resolve, reject) => {
        try {
          // Get the perceptions
          var tree = this.$store.getters['evaluations/perceptions'].tree
          var defaultValue = this.$store.getters['evaluations/perceptions'].defaultValue
          var parent = this
          // Get the snapshot
          var snapshot = this.perceptions.find(function (el) {
            return el.id == parent.selectedPerception
          })
          // Get assessment index
          var assessmentIndex = this.assessmentsRows.findIndex(function (el) { return el == 'perceptions' })
          this.assessments[assessmentIndex] = []

          // Store snapshot for other parts (header)
          this.assessmentsSnapshots[assessmentIndex] = snapshot

          // Parse the actual snapshot data
          snapshot = JSON.parse(snapshot.snapshot)
          let index = [ 0 ] // Value in array so it can be passed by reference.

          // Prepare the assessment
          this.$_prepareAssessment(snapshot, index, tree[0], defaultValue, '', assessmentIndex)

          // Display assessment
          Vue.set(this.displayAssessments, assessmentIndex, true)

          setTimeout(function () {
            return resolve(parent.displayAssessments[assessmentIndex])
          }, 250)
        } catch (err) {
          return reject(err)
        }
      })
    },

    $_prepareAssessment (data, index, node, defaultValue, numbering, assessmentIndex) {
      // Only save value of leafs.
      // If parent, go find the next leaf.
      if (node.children.length == 0) {
        let datas = data[index[0]]
        let value = defaultValue
        let comment = ''

        // If datas contain only one item
        //    -> if Number : value
        //    -> if String : comment
        // Else, contain value and comment.
        if (datas.length == 1) {
          if (Number.isInteger(datas[0])) {
            value = datas[0]
          } else {
            comment = datas[0]
          }
        } else if (datas.length == 2) {
          value = datas[0]
          comment = datas[1]
        }

        // Assign properties to node.
        Vue.set(node, 'value', value)
        Vue.set(node, 'comment', comment)

        var el = {
          code: numbering,
          description: this.$t(`evaluations.` + this.assessmentsRows[assessmentIndex] + `.titles.` + node.id),
          comment: comment,
          value: value
        }
        this.assessments[assessmentIndex].push(el)

        // Use next item in snapshot list.
        index[0] += 1
      } else {
        for (let i = 0; i < node.children.length; i++) {
          var nbr = (numbering == '') ? '' + (i + 1) : numbering + '.' + (i + 1)
          this.$_prepareAssessment(data, index, node.children[i], defaultValue, nbr, assessmentIndex)
        }
      }
    },

    hideAll () {
      this.displaySynthesis = false
      this.displayReports = this.displayReports.map(x => false)
      this.displayAssessments = this.displayAssessments.map(x => false)
      this.displayPenibility = false
      this.displayChart = false
      this.displayProfile = false
      this.displayAccompanyingS = false
      this.displayMask = false
      this.displayDecisions = false
      this.fullHeader = true
    },

    augmentWithDescription (obj, translationRoot) {
      var withDesc = []
      for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
          if (k == parseInt(k)) {
            var el = obj[k]
            el.description = this.$t(translationRoot + k)
            obj[k] = el
          }
        }
      }
      return obj
    },

    itemsCountChange (index, ...args) {
      Vue.set(this.itemsCount, index, args[0])
    },

    getMasks () {
      axios.get('/api/evaluations/masks')
        .then((response) => {
          this.masks = response.data
        })
        .catch((err) => {
        })
    },

    getAbilities () {
      axios.get(`/api/users/${this.recipient.id}/evaluations/abilities`)
        .then((response) => {
          this.abilities = response.data
        })
        .catch((err) => {
        })
    },
    getRequirements () {
      axios.get(`/api/users/${this.recipient.id}/evaluations/requirements`)
        .then((response) => {
          this.requirements = response.data
        })
        .catch((err) => {
        })
    },
    getPerceptions () {
      axios.get(`/api/users/${this.recipient.id}/evaluations/perceptions`)
        .then((response) => {
          this.perceptions = response.data
        })
        .catch((err) => {
        })
    },
    getArchives () {
      axios.get(`/api/reportarchives`)
        .then((response) => {
          this.archives = response.data
        })
        .catch((err) => {
        })
    },

    isCurrentUser () {
      return isCurrentUser(this.user, this.recipient)
    },

    addHeader (pdf, orientation = 'p') {
      var reportHeader = $('#' + this.headertable)[0]
      var res = pdf.autoTableHtmlToJson(reportHeader)
      var logo = $('#' + this.headertable + ' #logo-small')[0]
      var marginLeft = 20
      var startY = 20

      if (logo) {
        const imgHeight = 20
        const ratio = imgHeight / logo.height
        const base64 = this.$refs.header.base64Logo
        const imgWidth = ratio * logo.width

        pdf.addImage(base64, 'JPEG', marginLeft, startY, imgWidth, imgHeight)
      }

      pdf.autoTable(res.columns, res.rows, {
        theme: 'plain',
        tableWidth: 'auto',
        startY: 40,
        margin: {
          top: 20,
          left: 20,
          right: 20,
          bottom: 20
        },
        styles: {
          cellPadding: 1,
          fontSize: 8,
          cellWidth: 'auto',
          overflow: 'linebreak',
          textColor: 60,
          halign: 'left',
          valign: 'middle'
        },
        headStyles: {
          fillColor: false
        },
        columnStyles: {
          0: { cellWidth: 'auto', columnHeight: 30 },
          1: { cellWidth: orientation == 'l' ? 100 : 45 },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 'auto' }
          // etc
        }
      })

      // var tableEndY = pdf.autoTableEndPosY();
      var tableEndY = pdf.previousAutoTable.finalY
      return tableEndY > startY ? tableEndY : startY
    },

    //
    // PDF Code
    //

    generateTablePDF (tableID, filename, orientation, save = true) {
      filename = filename + '.pdf'
      var totalPagesExp = '{total_pages_count_string}'
      var pdf = new jsPDF(orientation, 'mm', 'A4')
      var startY = this.addHeader(pdf, orientation)
      var res = pdf.autoTableHtmlToJson($(tableID)[0])
      var header = this.headerFooter(pdf, 20, 20, totalPagesExp)

      pdf.autoTable(res.columns, res.data, {
        didDrawPage: header,
        tableWidth: 'auto',
        startY: startY + this.pdfTopMargin,
        margin: {
          top: 30,
          left: 20,
          right: 20,
          bottom: 30
        },
        styles: {
          overflow: 'linebreak',
          fontSize: this.pdfDefaultFontSize,
          cellWidth: 'auto'
        },
        headStyles: {
          fillColor: 0,
          minCellWidth: 20
        }
      })

      if (typeof pdf.putTotalPages === 'function') {
        pdf.putTotalPages(totalPagesExp)
      }

      if (save) { pdf.save(filename) } else { return pdf.output('blob') }
    },

    generateTablePDFPenibility (tableID, filename, orientation) {
      filename = filename + '.pdf'

      const totalPagesExp = '{total_pages_count_string}'
      const pdf = new jsPDF(orientation, 'mm', 'A4')
      const res = pdf.autoTableHtmlToJson($(tableID)[0])
      const startY = this.addHeader(pdf, orientation)
      const header = this.headerFooter(pdf, 20, 20, totalPagesExp)
      const informations = this.$i18n.t('reports.penibility_informations')

      pdf.setFontSize(8)
      pdf.text(informations, 20, startY + 20, { maxWidth: 170, align: 'justify' })
      pdf.autoTable(res.columns, res.data, {
        didDrawPage: header,
        tableWidth: 'auto',
        startY: 130,
        margin: {
          top: 30,
          left: 20,
          right: 20,
          bottom: 30
        },
        styles: {
          overflow: 'linebreak',
          fontSize: this.pdfDefaultFontSize,
          cellWidth: 'auto'
        },
        showHead: 'never',
        alternateRowStyles: {
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        }
      })

      if (typeof pdf.putTotalPages === 'function') {
        pdf.putTotalPages(totalPagesExp)
      }

      pdf.save(filename)
    },

    generateMultiTablePDF (tableID, filename, orientation) {
      const customMargins = 20
      const customWidth = 190

      filename = filename + '.pdf'

      var totalPagesExp = '{total_pages_count_string}'
      var pdf = new jsPDF(orientation, 'mm', 'A4')
      var startY = this.addHeader(pdf, orientation)

      var pageHeight = orientation == 'p' ? 297 : 210
      var tables = $('[id^="' + tableID + '"]')
      var titles = $('[id^="tabletitle"]').map(function (i, x) {
        // Skip titles with empty tables after
        if ($(x).next('table').find('tr').length != 0 && $(x).next('h5').length != 0) { return }

        return {
          id: x.id.replace('tabletitle', ''),
          element: x
        }
      })

      var customCreatedCell = function (cell, data) {
        cell.cell.styles.textColor = 80
        cell.cell.styles.fontStyle = 'normal'
        cell.cell.styles.fillColor = false
        cell.cell.styles.fontSize = 8
        if (cell.cell.raw.nodeName == 'TH') {
          cell.cell.styles.textColor = 0
          cell.cell.styles.fontStyle = 'bold'
        }
        // if ((data.row.index + 1) % 2 == 0) {
        //   cell.styles.fillColor = 245;
        // }
        if (cell.cell.raw.className == 'details') {
          cell.cell.styles.fontStyle = 'italic'
          cell.cell.styles.textColor = [0, 81, 135]
        } else if (cell.cell.raw.className == 'subtitle') {
          cell.cell.styles.textColor = 0
        }
      }

      var already_printed = []

      for (var i = 0; i < tables.length; i++) {
        var currenttable = tables[i]
        var numbers = currenttable.id.match(/\d+/g)
        // var y = i == 0 ? startY : pdf.autoTableEndPosY();
        var y = i == 0 ? startY : pdf.previousAutoTable.finalY

        if ($(currenttable).find('tr').length == 0) {
          // $(currenttable).append('<tbody><tr><td>Test<br/>2 lines</td><td></td></tr></tbody>')
          continue
        }

        // Space between titles.
        y += currenttable.id.includes('nomargin') ? 0 : customMargins

        var associatedTitles = titles.filter((i, title) => {
          var indices = title.id.match(/\d+/g)
          if (indices.length == numbers.length) {
            return indices.filter((x, i) => x == numbers[i]).length == numbers.length
          } else if (indices.length == 1 && numbers.length == 2) {
            return indices[0] == numbers[0] && numbers[1] == 1 // display above first title of the branch only
          } else if (numbers.length == 1 && indices.length == 2) {
            return numbers[0] == indices[0] && indices[1] == 1
          }
          return false
        }, numbers)

        if (associatedTitles.length > 0) {
          for (var k = 0; k < associatedTitles.length; k++) {
            if (y > pageHeight - customMargins - 5) {
              pdf.addPage()
              pdf.setFontSize(8)
              pdf.setTextColor(125, 125, 125)
              pdf.setFontStyle('normal')

              y = customMargins + 10 // Start to draw tables from here.

              if (pdf.internal.getNumberOfPages() > 1) {
                pdf.text(this.headerText, customMargins, customMargins)
              }

              // FOOTER
              var footer = 'Page ' + pdf.internal.getNumberOfPages()
              // Total page number plugin only available in jspdf v1.0+
              if (typeof pdf.putTotalPages === 'function') {
                footer = footer + ' / ' + totalPagesExp
              }

              var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight()
              pdf.text(footer, customMargins, pageHeight - customMargins)
              pdf.setTextColor(0, 0, 0)
            }

            let node = associatedTitles[k]

            if (already_printed.includes(node.id)) { continue }

            var headings = []
            var text = node.element.innerText

            // Break long titles to multiple lines.
            if (text.length > 100) {
              var words = text.split(' ')
              var index = 0
              var len = words[0].length
              while (len < 100 && index < words.length - 1) {
                index++
                len += 1 + words[index].length // add space too
              }
              headings.push(words.splice(0, index).join(' '))
              headings.push(words.join(' '))
            } else {
              headings.push(text)
            }

            if (node.element.nodeName == 'H5') { pdf.setFontSize(10) } else if (node.element.nodeName == 'H3') { pdf.setFontSize(14) } else { pdf.setFontSize(this.pdfDefaultFontSize) }

            // Titles
            for (var n = 0; n < headings.length; n++) {
              pdf.text(customMargins, y, headings[n])
              y += headings.length - (n + 1) > 0 ? 5 : 0
            }

            already_printed.push(node.id)
            pdf.line(customMargins, y + 2, customWidth, y + 2)
            y += associatedTitles.length - (k + 1) > 0 ? 7 : 3
          }
        }

        var res = pdf.autoTableHtmlToJson(tables[i])
        // console.log(tables[i]);
        // console.log(res);
        if (res.columns) {
          pdf.autoTable(res.columns, res.data, {
            didDrawPage: this.headerFooter(pdf, customMargins, customMargins, totalPagesExp, i == 0 ? i : pdf.internal.getNumberOfPages()),
            tableWidth: 'auto',
            startY: y,
            theme: 'grid',
            margin: {
              top: customMargins * 1.5,
              left: customMargins,
              right: customMargins,
              bottom: customMargins * 1.5
            },
            showHead: 'firstPage',
            styles: {
              cellPadding: 1,
              fontSize: 8,
              overflow: 'linebreak',
              cellWidth: 'auto',
              valign: 'middle'
            },
            headStyles: {
              cellPadding: 1,
              overflow: 'linebreak',
              cellWidth: 'auto',
              fontSize: 1
            },
            didParseCell: customCreatedCell,
            willDrawCell (data) {
              // console.log(data.cell.raw.innerHTML);
              // console.log(data);
              if (data.section === 'head') {
                // return false
              }
            }
          })
        }
      }

      if (typeof pdf.putTotalPages === 'function') {
        pdf.putTotalPages(totalPagesExp)
      }
      pdf.save(filename)
    },

    generateChartPDF (canvasID, filename, orientation, save = true) {
      filename = filename + '.pdf'
      var pdf = new jsPDF(orientation, 'mm', 'A4')
      var startY = this.addHeader(pdf, orientation)
      var docWidth = orientation == 'l' ? 287 : 170 // mm -> A4 (210x297) minus 5mm margin each side

      var parent = this
      $(canvasID).each(function (index) {
        var canvasChart = $(this)[0]
        var base64Chart = canvasChart.toDataURL('image/png')
        var widthChart = canvasChart.width
        var heightChart = canvasChart.height
        var ratioChart = heightChart / widthChart

        if (index > 0) { pdf.addPage() }

        pdf.addImage(base64Chart, 'JPEG', 20, parent.pdfTopMargin + startY, docWidth, docWidth * ratioChart)
      })

      if (save) { pdf.save(filename) } else { return pdf.output('blob') }
    },

    generateMaskPDF (divID, title, filename, orientation) {
      var totalPagesExp = '{total_pages_count_string}'
      filename = filename + '.pdf'
      var pdf = new jsPDF(orientation, 'mm', 'A4')
      var startY = this.addHeader(pdf, orientation)
      startY += 10
      var pageHeight = orientation == 'p' ? 297 : 210
      pdf.text(12, startY, title)
      startY += 10
      var masksNodes = $(divID + ' label')
      var rangeStr = Array.from(Array(5).keys()).join('  ')
      for (var i = 0; i < masksNodes.length; i++) {
        pdf.setFontSize(10)
        pdf.setTextColor(0, 0, 0)
        var node = masksNodes[i]
        var id = node.id
        var x = 12
        x += (id.split('.').length - 1) * 8 // shift 8mm per tree sub-level
        var text = node.innerHTML.replace(/(\r\n\t|\n|\r\t)/gm, '')
        pdf.text(x, startY, text)
        if (node.className == 'show-range') {
          // YGO 13.01.2020, deactivated range as we added a blank field for entering the value (but keeping the code if needed to reactivate it later)
          // var w = pdf.getTextDimensions(text).w * 0.37; // convert points to milimeters a bit less (knowing 1pt is 0.3527777778 mm) because the TextDimension function overestimate trv3 h4x00rr
          // pdf.setFontSize(8);
          // pdf.setTextColor(100, 100, 100);
          // pdf.text(x + w, startY, rangeStr);
          pdf.setDrawColor(150, 150, 150)
          pdf.rect(x - 8, startY - 4, 5, 5, 'S')
        }
        startY += 6
        if (startY > (pageHeight - this.pdfTopMargin)) {
          pdf.addPage()
          startY = this.pdfTopMargin
          pdf.setFontSize(8)
          pdf.setTextColor(125, 125, 125)
          pdf.setFontStyle('normal')
          if (pdf.internal.getNumberOfPages() > 1) { pdf.text(this.headerText, 12, this.pdfTopMargin / 2) }

          // FOOTER
          var str = 'Page ' + pdf.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof pdf.putTotalPages === 'function') {
            str = str + ' / ' + totalPagesExp
          }
          var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight()
          pdf.text(str, 12, pageHeight - this.pdfTopMargin / 2)
        }
      }

      if (typeof pdf.putTotalPages === 'function') {
        pdf.putTotalPages(totalPagesExp)
      }
      pdf.save(filename)
    },

    headerFooter (pdf, headerY, footerY, totPagePattern, currentPage = 0) {
      // HEADER
      var text = this.headerText
      return function (data) {
        if (currentPage < pdf.internal.getNumberOfPages()) {
          pdf.setFontSize(8)
          pdf.setTextColor(125, 125, 125)
          pdf.setFontStyle('normal')
          if (data.pageCount > 1) { pdf.text(text, data.settings.margin.left, headerY) }

          // FOOTER
          var str = 'Page ' + pdf.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof pdf.putTotalPages === 'function') {
            str = str + ' / ' + totPagePattern
          }
          var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight()
          pdf.text(str, data.settings.margin.left, pageHeight - footerY)
        }
      }
    },

    generateWordDocument (filename, orientation = 'p') {
      var css = orientation == 'l' ? this.wordLandscape : ''
      this.exportToWord(this.$refs.reportsContent.innerHTML, filename)
    },

    generateChartWordDocument (canvasID, filename, orientation = 'p') {
      var parent = this
      // TODO YGO : Remove the chart update and loop the charts
      // this.$refs.chart.update(function () {

      var root = $('<div/>', {
        id: 'chart-container'
      })
      $('#header').clone().appendTo(root)
      $(canvasID).each(function (index) {
        var canvasChart = $(this)[0]
        // console.log(canvasChart);
        var base64Chart = canvasChart.toDataURL('image/png')
        var widthChart = canvasChart.width
        var heightChart = canvasChart.height
        var ratioChart = heightChart / widthChart
        // var css = orientation == 'l' ? parent.wordLandscape : "";

        var img = new Image()
        img.src = base64Chart
        img.width = 550
        img.height = parseInt(Math.ceil(img.width * ratioChart))
        img.onload = function () {
          root.append(img)
        }
      })
      setTimeout(function () {
        parent.exportToWord(root[0].innerHTML, filename)
      }, 100)
      // })
    },

    generateCSV (tableID, filename) {
      var table = $(tableID)
      var data = []
      table.find('tr').each(function () {
        var line = $(this).find('th, td').map(function () {
          return '"' + $(this).text().trim() + '"'
        }).get()
        data.push(line)
      })
      this.exportCSV(data, filename)
    },

    // TODO YGO : continue here
    generateCSVPenibility (penibilities, filename) {
      var headers = ['code', 'description', 'max score', 'score', 'penibility rate']
      var data = []
      data.push(headers)
      var types = ['global', 'intellectual', 'physical']
      for (var type of types) {
        for (var key in penibilities[type]) {
          if (!isNaN(key)) {
            var p = penibilities[type][key]
            var line = [
              p.code,
              p.description,
              p.max_score,
              p.score,
              type
            ]
            data.push(line)
          }
        }
      }
      this.exportCSV(data, filename)
    },

    exportToWord (html, fileName) {
      const source = wordTemplate.replace('[TITLE]', fileName).replace('[HTML]', html)

      const file = fileName + '.doc'
      const blob = new Blob([source], { type: 'application/vnd.ms-word' })

      if (window.top.navigator.msSaveOrOpenBlob) {
        // Store Blob in IE.
        window.top.navigator.msSaveOrOpenBlob(blob, file)
      } else {
        // Store Blob in others.
        var element = document.body.appendChild(document.createElement('a'))
        element.href = URL.createObjectURL(blob)
        element.download = file
        element.style.display = 'none'
        element.click()
        element.parentNode.removeChild(element)
      }
    },
    exportCSV (data, fileName) {
      const source = data.map(e => e.join(';')).join('\n')

      const file = fileName + '.csv'
      const blob = new Blob([source], { type: 'text/csv' })

      if (window.top.navigator.msSaveOrOpenBlob) {
        // Store Blob in IE.
        window.top.navigator.msSaveOrOpenBlob(blob, file)
      } else {
        // Store Blob in others.
        var element = document.body.appendChild(document.createElement('a'))
        element.href = URL.createObjectURL(blob)
        element.download = file
        element.style.display = 'none'
        element.click()
        element.parentNode.removeChild(element)
      }
    },
    async deleteArchive (archive) {
      // Send request
      await axios.delete(`/api/reportarchives/` + archive.id)
        .then((response) => {
        // Remove item from list.
          let index = this.archives.indexOf(archive)
          this.archives.splice(index, 1)
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }
}
</script>
<style lang="scss">
#reports-content {
  h1 { margin: 3rem 0 2rem 0; }
  h3 { margin: 2rem 0 1rem 0; }

  #header {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Reports.vue